import styled from 'styled-components';
import { Box, Grid, Button, MenuItem } from '@mui/material';
import { colors } from 'spw-theme';
import { GridProps } from '@mui/material/Grid';
import React from 'react';
import CardAtom from 'spw-components/atomic/atoms/card';

export const ExportButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
`;

export const SummaryContainer = styled(Grid).withConfig({
  shouldForwardProp: (prop) => !['shouldHideBackground'].includes(prop),
})`
  && {
    background: ${(props: { shouldHideBackground?: boolean }) =>
      props.shouldHideBackground ? 'none' : colors.lightGreyBackground};
    padding: 16px;
  }
`;

export const SummaryMessage = styled.span`
  font-family: Roboto;
  line-height: 20px;
  font-size: 16px;
  font-weight: 500;
  padding: 6px;
`;

export const Card = CardAtom;

export const CardTitle = styled.div`
  && {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    color: ${colors.mainGray};
  }
`;

export const CardValueTitle = styled.div`
  && {
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    color: ${colors.mainGray};
  }
`;

export const HeadcountIconWrapper = styled(Box)`
  && {
    margin-right: 16px;
  }
`;

export const BreakdownRow = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    margin-bottom: 8px;
    &.last {
      padding-bottom: 10px;
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 8px;
    }
  }
`;

export const BreakdownColumn = styled(Grid)`
  && {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    &.right {
      text-align: right;
    }
    &.error {
      color: ${colors.red};
    }
  }
`;

export const BreakdownBottomRow = styled(BreakdownRow)`
  && {
    margin-bottom: 0;
  }
`;

export const BreakdownTotalRow = styled(BreakdownRow)`
  && {
    margin-bottom: 24px;
    color: #4a4a4a;
  }
`;

export const PercentValue = styled.span`
  && {
    font-weight: bold;
    padding-left: 2px;
  }
`;

export const CardSmallValue = styled.span`
  && {
    font-weight: 500;
    font-size: 12px;
    line-height: normal;
    color: ${colors.black};
    &.mr-5 {
      margin-right: 5px;
    }
  }
`;

export const Pill = styled.div`
  && {
    background-color: ${(props) => (props.color ? props.color : '#eeeeee')};
    width: 100%;
    max-height: 18px;
    padding-left: 4px;
    border-radius: 11px;
    display: flex;
    justify-content: start;
    align-items: center;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;

    &:hover {
      &.highlight {
        background: #eeeeee;
        cursor: pointer;
      }
    }

    &.margin-left {
      margin-left: -4px;
    }
  }
`;

export const SubtitleText = styled.div`
  && {
    font-size: 12px;
    line-height: 16px;
    color: ${colors.fontColor};
    width: 100%;
  }
`;

export const BigKey = styled.div`
  && {
    font-size: 12px;
    line-height: 16px;
    color: ${colors.fontColor};
  }
`;

export const MixBarHeader = styled.div`
  && {
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    text-transform: uppercase;
    color: ${colors.black};
    width: 100%;
    white-space: nowrap;
  }
`;

export const ShowDecimalsContainer = styled(Box)`
  flex-grow: 1;
  text-align: right;
`;

export const MoreButton = styled(Button)`
  && {
    min-width: auto;
  }
`;

export const ShowDecimalsMenuItem = styled(MenuItem)`
  height: 52px;
  font-size: 18px;
  line-height: 20px;
  padding: 16px;
`;
